import { render, staticRenderFns } from "./ClinicFeatureSection.vue?vue&type=template&id=6cb89141&"
import script from "./ClinicFeatureSection.vue?vue&type=script&lang=js&"
export * from "./ClinicFeatureSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports